import FinalAdvice from './FinalAdvice';

export default FinalAdvice;